import React from 'react';

export const BurgerMenu: React.FC = () => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="2" fill="#697684" />
      <rect y="8" width="24" height="2" fill="#697684" />
      <rect y="16" width="24" height="2" fill="#697684" />
    </svg>
  );
};
